export const ANIMATION_DURATION_MS: number = 2400;

export const getAnimationOffset = (elapsedMilliseconds: number): string => {
  const progress: number = Math.round(elapsedMilliseconds % ANIMATION_DURATION_MS);

  return `-${progress}ms`;
};
